import React, { Component, Fragment } from "react"
import {
  EuiSpacer,
  EuiText} from '@elastic/eui'

import {
  ReactiveBase,
  DataSearch,
  ReactiveList,
  ResultList,
} from "@appbaseio/reactivesearch"

import { _connectionString, _index_wiki } from './ElasticParam'

const { ResultListWrapper } = ReactiveList

class ReactiveSearch extends Component {
  render() {
    return (
      <Fragment>
        <ReactiveBase
          url={_connectionString}
          app={_index_wiki}
          theme={{
            colors: {
              primaryColor: "#bebebe",
              textColor: "#7e7e7e"
            },
          }}
        >
          <DataSearch
            componentId="q"
            placeholder="INSTAR Search Assistant"
            dataField={["title", "tags", "abstract", "description"]}
            fieldWeights={[8, 10, 5, 3]}
            searchOperators={false}
            autosuggest={true}
            highlight={false}
            fuzziness={1}
            debounce={100}
            URLParams={false}
            defaultValue="⁇"
          />
          <div style={{ display: 'flex', marginTop: 20 }}>
            <ReactiveList
              from={0}
              react={{
                and: ["q"],
              }}
              componentId="SearchResult"
              dataField="chapter.raw"
              stream={true}
              pagination={true}
              paginationAt="bottom"
              size={5}
              loader="Loading Results.."
              showResultStats={true}
              scrollOnChange={true}
            >
              {({ data }) => (
                <div style={{ marginLeft: 20, padding: 10 }}>
                  <ResultListWrapper>
                    {data.map((item) => (
                      <div style={{ background: 'white', margin: '10px 0', padding: '7px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }} key={item._id}>
                        <ResultList href={'/en'+item.sublink1} onClick={this.props.closeFlyout}>
                            <ResultList.Image src={item.imagesquare} style={{ minWidth: 125 }} />
                            <ResultList.Content>
                              <EuiText size="s">
                                <ResultList.Title
                                  dangerouslySetInnerHTML={{
                                    __html: item.title,
                                  }}
                                />
                                <EuiSpacer />
                                <ResultList.Description
                                  dangerouslySetInnerHTML={{
                                    __html: item.abstract,
                                  }}
                                />
                              </EuiText>
                            </ResultList.Content>
                          </ResultList>
                      </div>
                    ))}
                  </ResultListWrapper>
                </div>
              )}
            </ReactiveList>
          </div>
        </ReactiveBase>
      </Fragment>
    );
  }
}

export default ReactiveSearch
